<script setup lang="ts">
  import { useProfileStore } from "@/store/ProfileStore"
  import { computed } from "vue"
  const profileStore = useProfileStore()
  const visible = computed(() => profileStore.profile === undefined)
  const setProfile = (profile: number) => {
    profileStore.profile = profile
  }
</script>

<template>
  <Dialog
    v-model:visible="visible"
    append-to="body"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '96vw' }"
    :style="{
      width: '700px',
      borderRadius: '1.5rem',
      boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
    }"
    :closable="false"
    :show-header="false"
    class="fade-in-dialog">
    <div class="flex flex-col items-center my-8 animate-fade-in">
      <span
        class="w-20 h-20 flex items-center justify-center bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-white rounded-full shadow-lg mb-6 text-4xl font-bold select-none">
        ?
      </span>
      <div
        class="font-bold text-3xl text-surface-900 dark:text-surface-0 mb-2 text-center">
        Merci d'indiquer votre profil d'investisseur
      </div>
      <div
        class="text-base text-gray-600 dark:text-gray-300 text-center max-w-xl">
        Pour accéder à l'ensemble des fonctionnalités et contenus, veuillez
        sélectionner le profil qui correspond le mieux à votre situation. Cette
        information nous permet d'adapter l'expérience à vos besoins.
      </div>
    </div>

    <template #footer>
      <div
        class="border-t border-surface pt-6 flex w-full gap-4 justify-center flex-col sm:flex-row">
        <Button
          label="Institutionnels et entreprises"
          class="sm:w-1/3 w-full py-3 px-2 text-base font-semibold rounded-lg bg-blue-600 hover:bg-blue-700 text-white shadow transition-all duration-200"
          @click="setProfile(1)" />
        <Button
          label="Professionnels du patrimoine"
          class="sm:w-1/3 w-full py-3 px-2 text-base font-semibold rounded-lg bg-fuchsia-600 hover:bg-fuchsia-700 text-white shadow transition-all duration-200"
          @click="setProfile(2)" />
        <Button
          label="Clients particuliers"
          class="sm:w-1/3 w-full py-3 px-2 text-base font-semibold rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white shadow transition-all duration-200"
          @click="setProfile(3)" />
      </div>
    </template>
  </Dialog>
</template>
<style scoped>
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .animate-fade-in {
    animation: fade-in 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .fade-in-dialog {
    animation: fade-in 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
</style>
